export default "__VITE_ASSET__D72l16ii__"